import React from 'react';
import {withRouter} from 'react-router-dom';

import {AppContext} from '../../../AppModule/Context';
import {withWidgetContext} from '../widgetContextProvider';

import CallInitiator from '../../callComponents/callInitiator';
import DagComponent from '../../dagModule/dagComponent';
import EngagerReceiverComponent from '../../dagModule/engageReceiverComponent';
import PersonalPageComponent from '../../personalPageComponent/personalPageComponent';
import ResourcePermissionsComponent from '../../common/genericComponents/resourcePermissionsComponent';
import ThreedClientContainerComponent from '../../threedComponents/threedClientContainerComponent';
import WidgetComponent from '../widgetComponent';

import AnalyticsService from '../../../services/analyticsService';
import PaymentRequestReceiverComponent from '../../paymentRequestComponent/paymentRequestReceiverComponent';
import postMessageService from '../../../services/postMessageService';
import resourcePermissionsService from '../../../services/resourcePermissionsService';
import utilsService from '../../../services/utilsService';
import {WSService} from '../../../services/websocketService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './SingleExpertWidget.css';

class SingleExpertWidget extends React.Component {
  // responsible for loading data (mentorDto, sessionTemplateDto, image...); communicating with iframeApp; controling widget size;
  constructor(props) {
    super();
    this.isInPersonalPage = utilsService.getIsPersonalPage();
    this.state = {
      // sessionTemplateReceived: false,
      WSConnected: WSService.socketEstablished,
      readyForCallInitiator: false,
      extendedMentorDto: props.extendedMentorDto,
      defaultSession: props.extendedMentorDto?.sessionTemplateDto,
      showNotificationPopupForWait: false,
      scheduledCallTimeReferenceCount: 0,
      isClearedManually: false,
      showPermissionsPopup: false,
      permissionsStatusesObj: {
        [VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA]:
          VIDABOO_CONSTANTS.PERMISSION_STATUS.DENIED,
        [VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE]:
          VIDABOO_CONSTANTS.PERMISSION_STATUS.DENIED,
      },
      isCallAudioOnly: false,
      selectedWidgetAppType: null,
    };
    this.validatePageRegexesTrials = 0;
  }

  componentDidMount = () => {
    this.widgetContext = this.props.widgetContext;
    // if (!this.fncObjToChatContainer) {
    //   this.fncObjToChatContainer = {
    //     getPeerDetails: this.getPeerDetails,
    //   };
    // }

    this.callInitFncObj = {
      changeIframeSize: this.changeIframeSize,
      closeWindow: this.closeWindow,
      mentorProfileImage: this.state.mentorProfileImage,
    };

    this.doWhenWidgetDtoReceived();

    this.deletePermissionHandler =
      resourcePermissionsService.registerHandlePermissionChangeFunc(
        this.handlePermissionChange,
      );
    this.setInitialPermissionsStatuses();
    this.openChatIfPreChatMsg();
  };

  componentDidUpdate = () => {
    if (
      this.props.startChatWithPeerId ===
        this.state.extendedMentorDto?.mentorDto?.mentorOwnerId &&
      this.startChatWithPeerId !== this.props.startChatWithPeerId
    ) {
      this.startChatWithPeerId = this.props.startChatWithPeerId;
      this.sendStartChatGA();
    }
  };

  componentWillUnmount = () => {
    this.deletePermissionHandler && this.deletePermissionHandler();
    if (this.validatePageRegexTimeout) {
      window.clearTimeout(this.validatePageRegexTimeout);
    }
    if (this.peerStatusTimeoutId) {
      window.clearTimeout(this.peerStatusTimeoutId);
    }
    if (this.startCallTimeoutId) {
      window.clearTimeout(this.startCallTimeoutId);
    }
  };

  openChatIfPreChatMsg = () => {
    if (this.widgetContext.preChatClientMsgToSend)
      this.onFooterOptionSelected(VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT);
  };

  sendStartChatGA = () => {
    this.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_CHAT,
      this.state.extendedMentorDto.mentorDto.profileName,
    );
    this.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_CHAT,
    );
  };

  hideWidget = () => {
    if (!this.props.isInAccount) {
      this.changeIframeVisibility('hidden');
    }
  };
  showWidget = () => {
    this.changeIframeVisibility('visible');
  };

  doWhenWidgetDtoReceived = () => {
    const language =
      this.props.extendedMentorDto?.mentorDto?.uiLanguage ||
      this.props.widgetDto.widgetAppCtrlDto.uiLanguage ||
      'ENGLISH';
    this.context.setLanguage(language);
    if (!this.props.isInAccount) {
      // postMessageService.setWidgetInfo(
      //   widgetDto.widgetAppCtrlDto.widgetInteractionMode,
      //   widgetDto.widgetAppCtrlDto.closedWidgetType,
      //   widgetDto.widgetAppCtrlDto.style.locationOnScreen,
      // );
      this.changeIframeSize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED,
        'singleExpertWidget',
      );
    }
    // this.sendPageviewAnalyticsEvent();
    // ChatService.addPeerSpecificFnc(
    //   this.state..mentorDto.mentorOwnerId,
    //   this.fncObjToChatContainer,
    // );

    if (this.state.extendedMentorDto?.mentorDto?.appControlDto) {
      if (
        this.state.extendedMentorDto.mentorDto.appControlDto.widgetVisible ===
        false
      ) {
        this.hideWidget();
        // console.debug("hideWidget
      } else {
        if (
          this.validatePageRegexes(
            this.state.extendedMentorDto.mentorDto.appControlDto.pagesRegexes,
          ) ||
          this.props.isInAccount
        ) {
          this.showWidget();
        }
      }
    }
    this.doWhenWSConnectedAndMentor();
    if (this.props.inTeamChatScenario) {
      const teamMentorDto = this.props.widgetDto.teamMentorsMapDto;
      const teamMentorPhotoDto =
        Object.values(teamMentorDto)[0]?.extendedMentorDto?.photoDto;

      const widgetProfilePhotoDto =
        teamMentorPhotoDto ??
        utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
          this.props.widgetDto.widgetAppCtrlDto.photoDtos,
          VIDABOO_CONSTANTS.PHOTO_TYPES.PROFILE,
          VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.WIDGET,
        )?.photoDto;
      if (widgetProfilePhotoDto) {
        const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
          widgetProfilePhotoDto,
          VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
        );
        this.setState({widgetProfileImage: manipulatedPhotoUrl});
      }
    } else {
      const mentorPhotoDto = this.props.extendedMentorDto?.photoDto;
      if (mentorPhotoDto) {
        const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
          mentorPhotoDto,
          VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
        );
        this.setState({mentorProfileImage: manipulatedPhotoUrl});
      }
    }
  };

  validatePageRegexes = (pageRegexArr) => {
    if (
      pageRegexArr === undefined ||
      pageRegexArr === null ||
      pageRegexArr.length === 0
    )
      return true;
    const currentParentFullPath = postMessageService.getLocation();
    if (currentParentFullPath === undefined || currentParentFullPath === null) {
      // in this case we cannot perform regex check. will wait for few moments and try again.
      if (this.validatePageRegexesTrials <= 8) {
        this.validatePageRegexTimeout = setTimeout(() => {
          this.validatePageRegexesTrials++;
          return this.validatePageRegexes(pageRegexArr);
        }, 500);
      } else return false;
    } else {
      for (var index = 0; index < pageRegexArr.length; index++) {
        if (currentParentFullPath.fullUrl.search(pageRegexArr[index]) >= 0) {
          return true;
        }
      }
      return false;
    }
  };

  doWhenWSConnectedAndMentor = async () => {
    this.setState({readyForCallInitiator: true});
    if (this.doWhenReadyForCallInitiator) this.doWhenReadyForCallInitiator();
  };

  changeIframeSize = (size, initiator, visibility) => {
    // console.debug("CHANGING SIZE: ", size, " ", initiator);

    if (
      size === VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED &&
      utilsService.isMobileDevice() //todomcss : Ilan? -> fix using windowScreenSize
    )
      size = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED_TINY;
    if (utilsService.getIsInWidget()) {
      postMessageService.setHomePage(
        this.state.extendedMentorDto.mentorDto.homeSite,
      );
      postMessageService.postMessageResize(size, initiator);
      if (visibility) {
        this.changeIframeVisibility(visibility, initiator);
      }
    }
    this.setState({iframeSize: size});
  };
  changeIframeVisibility = (visibility, initiator) => {
    if (utilsService.getIsInWidget()) {
      postMessageService.setHomePage(
        this.state.extendedMentorDto.mentorDto.homeSite,
      );
      postMessageService.postMessageHide(visibility, initiator);
    }
  };
  getPageLocation = () => {
    var pageLocation = postMessageService.getLocation();
    var error = false;
    if (
      utilsService.getIsInWidget() === true ||
      utilsService.getIsEmbeddedPersonalPage() === true
    ) {
      if (!pageLocation) {
        error = true;
        pageLocation = {
          fullUrl: window.location && window.location.href,
          hostUrl: 'Error Retrieving URL from host',
          error: error,
        };
      }
    } else {
      // in personal page
      // pageLocation = typeof document != 'undefined' ? document.location : null;
      pageLocation = {
        protocol: window.top.location.protocol,
        fullUrl: window.top.location.href,
        hostUrl: window.top.location.origin,
        pageUrl: window.top.location.pathname,
        hashUrl: window.top.location.hash,
        searchStr: window.top.location.search,
      };
    }
    return pageLocation;
  };
  // sendPageviewAnalyticsEvent = () => {
  //   var pageLocation = this.getPageLocation();
  //   var isInWidget = utilsService.getIsInWidget();
  //   AnalyticsService.saveConsoltoAnalyticsEvent({
  //     category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
  //     action: VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.PAGEVIEW.ENTER_PAGE,
  //     senderCreationTime: new Date().getTime(),
  //     userId: this.context.currentUser.userId,
  //     mentorId: this.state.extendedMentorDto.mentorDto.mentorId,
  //     userRole: this.context.currentUser.role,
  //     error: pageLocation.error,
  //     dimensionsMap: {
  //       fullUrl: pageLocation.fullUrl,
  //       hostUrl: pageLocation.hostUrl,
  //       pageUrl: pageLocation.pageUrl,
  //       hashUrl: pageLocation.hashUrl,
  //       searchStr: pageLocation.searchStr,
  //       widget: isInWidget,
  //       widgetId: this.props.widgetDto.widgetId,
  //       mentorUserId: this.state.extendedMentorDto.mentorDto.mentorOwnerId,
  //       deviceType: navigator.userAgent,
  //       timezone: new Date().getTimezoneOffset(),
  //     },
  //   });
  //   this.sendGA(
  //     VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.PAGEVIEW.ENTER_PAGE,
  //     this.state.extendedMentorDto.mentorDto.profileName,
  //     true,
  //   );
  // };
  sendCA = (eventAction) => {
    AnalyticsService.saveConsoltoAnalyticsEvent({
      category: this.isInPersonalPage
        ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
        : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: eventAction,
      userId: this.context.currentUser.userId,
      userRole: this.context.currentUser.role,
      mentorId: this.state.extendedMentorDto.mentorDto.mentorId,
      dimensionsMap: {
        widget: !this.isInPersonalPage,
        widgetId: this.props.widgetDto.widgetId,
        mentorOwnerId: this.state.extendedMentorDto.mentorDto.mentorOwnerId,
      },
    });
  };
  sendGA = (eventAction, label, noSendCA) => {
    AnalyticsService.trackEvent({
      category: this.isInPersonalPage
        ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
        : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: eventAction,
      label: label,
      value: '',
      sendToParent: this.isInPersonalPage
        ? false
        : this.props.widgetDto.widgetAppCtrlDto.enableWidgetAnalyticsForward ===
          true,
    });
    if (!noSendCA) this.sendCA(eventAction);
  };

  dispatchConsoltoEvents = (eventAction, label, value) => {
    if (utilsService.getIsInWidget()) {
      // if (this.props.isInAccount) {
      this.props.dispatchConsoltoEvents(
        eventAction,
        label ? label : this.state.extendedMentorDto.mentorDto.profileName,
        value,
      );
      // } else if (
      //   this.props.widgetDto.mentorDto.appControlDto
      //     .dispatchConsoltoWidgetEvents
      // ) {
      //   const eventObj = {
      //     category:
      //       VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET_FOR_PARENT_FRAME,
      //     action: eventAction,
      //     label: label ? label : this.props.widgetDto.profileName,
      //     value,
      //   };
      //   postMessageService.sendEventToHost(eventObj);
      // }
    }
  };

  waitTillPeerStatusArrive = (
    sessionTemplate,
    forceStartInPopup,
    sendAnalyticsEvent,
    peerClientInfo,
  ) => {
    if (
      this.context.peersStatus[
        this.state.extendedMentorDto.mentorDto.mentorOwnerId
      ] === undefined
    ) {
      if (this.peerStatusTimeoutId) {
        window.clearTimeout(this.peerStatusTimeoutId);
      }
      // wait
      this.peerStatusTimeoutId = setTimeout(() => {
        this.waitTillPeerStatusArrive(
          sessionTemplate,
          forceStartInPopup,
          sendAnalyticsEvent,
          peerClientInfo,
        );
      }, 250);
    } else {
      this.startCall(
        sessionTemplate,
        forceStartInPopup,
        sendAnalyticsEvent,
        peerClientInfo,
      );
    }
  };

  doWaitUntilPeerAvailableForCall = (
    sessionTemplate,
    forceStartInPopup,
    sendAnalyticsEvent,
    peerClientInfo,
  ) => {
    if (
      this.context.peersStatus[
        this.state.extendedMentorDto.mentorDto.mentorOwnerId
      ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
      this.context.peersStatus[
        this.state.extendedMentorDto.mentorDto.mentorOwnerId
      ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
    ) {
      if (!this.state.showNotificationPopupForWait) {
        this.setState({showNotificationPopupForWait: true});
      }
      // Wait for X seconds and then cancel,
      if (
        this.state.scheduledCallTimeReferenceCount * 250 >=
        (this.props.bfi
          ? VIDABOO_CONSTANTS.AUTO_CANCEL_TIME_FOR_SCHEDULED_CALLS
          : VIDABOO_CONSTANTS.AUTO_CANCEL_TIME_FOR_AUTOMATED_CALLS)
      ) {
        this.setState({
          scheduledCallTimeReference: null,
          scheduledCallTimeReferenceCount: 0,
          showNotificationPopupForWait: false,
          isClearedManually: false,
        });
        return;
      }
      // wait
      let scheduledCallTimeReference = setTimeout(() => {
        this.doWaitUntilPeerAvailableForCall(
          sessionTemplate,
          forceStartInPopup,
          sendAnalyticsEvent,
          peerClientInfo,
        );
      }, 250);
      this.setState({
        scheduledCallTimeReference,
        scheduledCallTimeReferenceCount:
          this.state.scheduledCallTimeReferenceCount + 1,
      });
    } else {
      this.setState({showNotificationPopupForWait: false});
      this.startCall(
        sessionTemplate,
        forceStartInPopup,
        sendAnalyticsEvent,
        peerClientInfo,
      );
    }
  };
  clearAutomatedCallLoop = () => {
    clearTimeout(this.state.scheduledCallTimeReference);
    this.setState({
      scheduledCallTimeReference: null,
      scheduledCallTimeReferenceCount: 0,
      showNotificationPopupForWait: false,
      isClearedManually: true,
    });
  };
  startCall = (
    sessionTemplate,
    forceStartInPopup,
    sendAnalyticsEvent,
    peerClientInfo,
    shouldSchedule,
  ) => {
    /* If personal page then check for status, if not available then
      keep checking for availability and start call once available */

    if (
      // utilsService.getIsPersonalPage() &&
      (this.context.peersStatus[
        this.state.extendedMentorDto.mentorDto.mentorOwnerId
      ] === undefined ||
        (this.context.peersStatus[
          this.state.extendedMentorDto.mentorDto.mentorOwnerId
        ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
          this.context.peersStatus[
            this.state.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY)) &&
      shouldSchedule
    ) {
      this.doWaitUntilPeerAvailableForCall(
        sessionTemplate,
        forceStartInPopup,
        sendAnalyticsEvent,
        peerClientInfo,
      );
      return;
    }
    if (
      // solving bug that happens when user starts call immediately.
      this.context.peersStatus[
        this.state.extendedMentorDto.mentorDto.mentorOwnerId
      ] === undefined
    ) {
      // wait
      this.waitTillPeerStatusArrive(
        sessionTemplate,
        forceStartInPopup,
        sendAnalyticsEvent,
        peerClientInfo,
      );
      return;
    }
    if (this.state.readyForCallInitiator) {
      this.callInitFncObj.startCall(
        sessionTemplate,
        forceStartInPopup,
        sendAnalyticsEvent,
        peerClientInfo,
      );
    } else {
      // should wait for "readyForCallInitiator"

      this.doWhenReadyForCallInitiator = () => {
        if (this.startCallTimeoutId) {
          window.clearTimeout(this.startCallTimeoutId);
        }
        this.startCallTimeoutId = setTimeout(() => {
          this.callInitFncObj.startCall(
            sessionTemplate,
            forceStartInPopup,
            sendAnalyticsEvent,
            peerClientInfo,
          );
        }, 250);
      };
    }
  };

  closeWindow = () => {
    //if we are within a popup and we got the close Popup, we should close the window.
    //todo: need to add here a check whether we are within a popup.
    window.close();
  };
  startVideochat = (peerClientInfo, isAudioCallOnly, shouldSchedule) => {
    const defaultSession = this.state.defaultSession;
    if (isAudioCallOnly) {
      defaultSession.sessionMode = isAudioCallOnly
        ? VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_ONLY
        : VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_VIDEO;
    }
    this.setState({defaultSession}, () => {
      this.startCall(
        this.state.defaultSession,
        false,
        true,
        peerClientInfo,
        shouldSchedule,
      );
    });
  };

  startVideochatFromEngager = () => {
    this.startCall(this.state.defaultSession, false, true);
  };
  postCallFailFnc = () => {
    this.setState({postCallFail: new Date()});
  };
  openThreedRequest = () => {};

  setSelectedWidgetAppType = (selectedWidgetAppType) => {
    if (
      selectedWidgetAppType ===
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR &&
      this.state.extendedMentorDto.mentorDto.appControlDto.widgetActionSelector
    ) {
      const actionSelectorHeaderText =
        this.state.extendedMentorDto.mentorDto.appControlDto
          .widgetEditableTexts &&
        this.state.extendedMentorDto.mentorDto.appControlDto
          .widgetEditableTexts[
          VIDABOO_CONSTANTS.WIDGET_APP_HEADER_TITLE_TYPES.ACTION_SELECTOR
        ];
      const postMsgData = {
        foregroundWidgetsLength:
          this.state.extendedMentorDto.mentorDto.appControlDto.foregroundWidgets
            .length,
        actionSelectorHeaderText,
      };
      postMessageService.postMessageResize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.ACTION_SELECTOR,
        'multiWidgetContainer',
        postMsgData,
      );
    }
    this.setState({selectedWidgetAppType});
  };

  onFooterOptionSelected = (selectedWidgetAppType) => {
    if (
      postMessageService.getWidgetSize() ===
      VIDABOO_CONSTANTS.WIDGET_SIZE.ACTION_SELECTOR
    ) {
      postMessageService.postMessageResize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
        'multiWidgetContainer',
      );
    }
    this.setState({
      selectedWidgetAppType,
    });
    if (
      !this.props.isDemo &&
      selectedWidgetAppType === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
    ) {
      //reset cue state
      this.context.setChatMessageCueCounter(true);
      this.context.setChatMessageCue(false);
    }
  };

  doWhenChatIconOrChatMsgNotificationClickedInCall = () => {
    if (
      this.state.selectedWidgetAppType !==
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
    ) {
      this.onFooterOptionSelected(VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT);
    }
  };

  setInitialPermissionsStatuses = async () => {
    try {
      const permissionsStatusesObj =
        await resourcePermissionsService.quietGetPermissions([
          VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA,
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE,
        ]);
      this.setState({permissionsStatusesObj});
    } catch (error) {
      console.debug('Error: ', error);
    }
  };

  handlePermissionChange = (permissionType, permissionStatus) => {
    let permissionsStatusesObj = {...this.state.permissionsStatusesObj};
    permissionsStatusesObj[permissionType] = permissionStatus;
    this.setState({permissionsStatusesObj});
  };

  setPermissionsStatusesObj = (permissionsStatusesObj) => {
    this.setState({permissionsStatusesObj});
  };

  setShowPermissionsPopup = (showPermissionsPopup) => {
    this.setState({showPermissionsPopup});
  };

  setIsCallAudioOnly = (isCallAudioOnly) => {
    this.setState({isCallAudioOnly});
  };

  handlePermissionsSuccess = (constraints) => {
    if (
      utilsService.getIsInSafariBrowser() ||
      utilsService.getIsInFirefoxBrowser()
    ) {
      let permissionsStatusesObj = {...this.state.permissionsStatusesObj};
      if (constraints.audio) {
        permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE] =
          VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
      }
      if (constraints.video) {
        permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] =
          VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
      }
      this.setState({
        showPermissionsPopup: false,
        permissionsStatusesObj,
      });
    } else {
      this.setState({
        showPermissionsPopup: false,
      });
    }
  };

  render() {
    const permissionsStatusesObj =
      [
        VIDABOO_CONSTANTS.VIDEO_CALL_STATE.SENDING_VIDEO_TO_PEER,
        VIDABOO_CONSTANTS.VIDEO_CALL_STATE.JOIN_CALL_REQUESTED,
        VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_IN_PROGRESS,
      ].includes(this.context.callState) || !this.state.isCallAudioOnly
        ? this.state.permissionsStatusesObj
        : {
            [VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE]:
              this.state.permissionsStatusesObj[
                VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
              ],
          };

    return (
      <div
        className={
          'et-expert-widget-container ' +
          (this.state.iframeSize === VIDABOO_CONSTANTS.WIDGET_SIZE.LARGE
            ? 'et-expert-widget-container-full-screen '
            : '') +
          (this.isInPersonalPage
            ? this.context.windowScreenSize ===
              VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE
              ? 'et-personal-page-mobile'
              : 'et-personal-page-desktop'
            : '')
        }>
        {this.state.showPermissionsPopup && (
          <ResourcePermissionsComponent
            permissionsStatusesObj={permissionsStatusesObj}
            closePopUp={() => {
              this.setShowPermissionsPopup(false);
            }}
            onPermissionsSuccess={this.handlePermissionsSuccess}
          />
        )}
        {!this.props.inTeamChatScenario && this.state.readyForCallInitiator && (
          <CallInitiator
            selectedWidgetAppType={this.state.selectedWidgetAppType}
            mentorStatus={
              this.context.peersStatus[
                this.state.extendedMentorDto.mentorDto.mentorOwnerId
              ]
            }
            defaultSession={this.state.defaultSession}
            mentor={this.state.extendedMentorDto}
            currentUser={this.context.currentUser}
            sessions={this.state.sessionsDto}
            enableWidgetAnalyticsForward={
              !this.isInPersonalPage &&
              this.props.widgetDto.widgetAppCtrlDto.enableWidgetAnalyticsForward
            }
            fldObj={this.callInitFldObj}
            fncObj={this.callInitFncObj}
            startCallOnInit={false}
            mentorProfileImage={this.state.mentorProfileImage}
            changeIframeSize={this.changeIframeSize}
            postCallFailFnc={this.postCallFailFnc}
            dispatchConsoltoEvents={this.dispatchConsoltoEvents}
            doWhenChatIconOrChatMsgNotificationClickedInCall={
              this.doWhenChatIconOrChatMsgNotificationClickedInCall
            }
            permissionsStatusesObj={this.state.permissionsStatusesObj}
            setShowPermissionsPopup={this.setShowPermissionsPopup}
          />
        )}
        {!this.props.inTeamChatScenario && this.state.readyForCallInitiator && (
          <EngagerReceiverComponent
            extendedMentorDto={this.state.extendedMentorDto}
            currentUser={this.context.currentUser}
            startVideochatFromEngager={this.startVideochatFromEngager}
            changeIframeSize={this.changeIframeSize}
            widgetContext={this.props.widgetContext}
            permissionsStatusesObj={this.state.permissionsStatusesObj}
            setPermissionsStatusesObj={this.setPermissionsStatusesObj}
            showPermissionsPopup={this.state.showPermissionsPopup}
            setShowPermissionsPopup={this.setShowPermissionsPopup}
            setIsCallAudioOnly={this.setIsCallAudioOnly}
          />
        )}

        {this.state.extendedMentorDto && (
          <>
            <ThreedClientContainerComponent
              extendedMentorDto={this.state.extendedMentorDto}
              closeThreed={this.closeThreed}
              changeIframeSize={this.changeIframeSize}
            />
            <PaymentRequestReceiverComponent
              chatRoomId={this.props.widgetContext.chatRoomId}
              extendedMentorDto={this.state.extendedMentorDto}
              currentUser={this.context.currentUser}
              defaultSession={this.state.defaultSession}
              selectedWidgetAppType={this.state.selectedWidgetAppType}
            />

            {false && !this.props.inTeamChatScenario && (
              <DagComponent
                peerUserId={
                  this.state.extendedMentorDto.mentorDto.mentorOwnerId
                }
                currentUser={this.context.currentUser}
                mentor={this.state.extendedMentorDto.mentorDto}
                widgetDto={this.props.widgetDto}
                getPageLocation={this.getPageLocation}
              />
            )}
          </>
        )}
        {this.state.extendedMentorDto && (
          <>
            {this.props.isDemo ||
            this.props.inTeamChatScenario ||
            utilsService.getIsInWidget() ||
            (this.isInPersonalPage &&
              this.context.windowScreenSize ===
                VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE) ? (
              <WidgetComponent
                canMoveToTeamChat={this.props.canMoveToTeamChat}
                enableWidgetAnalyticsForward={
                  !this.isInPersonalPage &&
                  this.props.widgetDto.widgetAppCtrlDto
                    .enableWidgetAnalyticsForward
                }
                isAutomatedCallHandled={this.props.isAutomatedCallHandled}
                isClearedManually={this.state.isClearedManually}
                isDemo={this.props.isDemo}
                isEntireWidgetHidden={this.props.isEntireWidgetHidden}
                isMultiWidget={this.props.isMultiWidget}
                inTeamChatScenario={this.props.inTeamChatScenario}
                isInAccount={this.props.isInAccount}
                showNotificationPopupForWait={
                  this.state.showNotificationPopupForWait
                }
                actionClickData={this.props.actionClickData}
                doWhenActionClick={this.props.doWhenActionClick}
                resetActionClickData={this.props.resetActionClickData}
                bfi={this.props.bfi}
                mentor={this.state.extendedMentorDto}
                mentorProfileImage={this.state.mentorProfileImage}
                permissionsStatusesObj={this.state.permissionsStatusesObj}
                postCallFail={this.state.postCallFail}
                selectedWidgetAppType={this.state.selectedWidgetAppType}
                sessionTemplate={this.state.defaultSession}
                // startChat={this.startChat}
                // startChatObj={this.state.startChatObj}
                // startChatWithPeer={this.state.startChatWithPeer}
                startValueFromQuery={this.props.startValueFromQuery}
                widgetDto={this.props.widgetDto}
                widgetProfileImage={this.state.widgetProfileImage}
                changeIframeSize={this.changeIframeSize}
                clearAutomatedCallLoop={this.clearAutomatedCallLoop}
                dispatchConsoltoEvents={this.dispatchConsoltoEvents}
                handlePermissionsSuccess={this.handlePermissionsSuccess}
                onFooterOptionSelected={this.onFooterOptionSelected}
                openCloseWidget={this.props.openCloseWidget}
                sendGA={this.sendGA}
                setIsAutomatedCallHandled={this.props.setIsAutomatedCallHandled}
                setIsCallAudioOnly={this.setIsCallAudioOnly}
                setPermissionsStatusesObj={this.setPermissionsStatusesObj}
                setSelectedWidgetAppType={this.setSelectedWidgetAppType}
                setShowPermissionsPopup={this.setShowPermissionsPopup}
                startVideochat={this.startVideochat}
                onHeaderBackButton={this.props.onHeaderBackButton}
                onHeaderCloseButton={this.props.onHeaderCloseButton}
              />
            ) : (
              <PersonalPageComponent
                isAutomatedCallHandled={this.props.isAutomatedCallHandled}
                isClearedManually={this.state.isClearedManually}
                bfi={this.props.bfi}
                extendedMentorDto={this.state.extendedMentorDto}
                mentor={this.state.extendedMentorDto}
                permissionsStatusesObj={this.state.permissionsStatusesObj}
                postCallFail={this.state.postCallFail}
                selectedWidgetAppType={this.state.selectedWidgetAppType}
                sessionTemplate={this.state.defaultSession}
                showNotificationPopupForWait={
                  this.state.showNotificationPopupForWait
                }
                startValueFromQuery={this.props.startValueFromQuery}
                widgetDto={this.props.widgetDto}
                clearAutomatedCallLoop={this.clearAutomatedCallLoop}
                handlePermissionsSuccess={this.handlePermissionsSuccess}
                onFooterOptionSelected={this.onFooterOptionSelected}
                sendGA={this.sendGA}
                setIsAutomatedCallHandled={this.props.setIsAutomatedCallHandled}
                setIsCallAudioOnly={this.setIsCallAudioOnly}
                setPermissionsStatusesObj={this.setPermissionsStatusesObj}
                setSelectedWidgetAppType={this.setSelectedWidgetAppType}
                setShowPermissionsPopup={this.setShowPermissionsPopup}
                startVideochat={(
                  peerClientInfo,
                  isAudioCallOnly,
                  shouldSchedule,
                ) => {
                  const defaultSession = this.state.defaultSession;
                  if (isAudioCallOnly) {
                    defaultSession.sessionMode = isAudioCallOnly
                      ? VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_ONLY
                      : VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_VIDEO;
                  }

                  this.setState({defaultSession}, () => {
                    this.startCall(
                      this.state.defaultSession,
                      false,
                      true,
                      peerClientInfo,
                      shouldSchedule,
                    );
                  });
                }}
              />
            )}
          </>
        )}
      </div>
    );
  }
}
SingleExpertWidget.contextType = AppContext;
export default withRouter(withWidgetContext(SingleExpertWidget));
